export default "__VITE_ASSET__095a5579__"